import { render, staticRenderFns } from "./PanelSummary.vue?vue&type=template&id=5eb8c0c6&scoped=true"
import script from "./PanelSummary.vue?vue&type=script&lang=js"
export * from "./PanelSummary.vue?vue&type=script&lang=js"
import style0 from "./PanelSummary.vue?vue&type=style&index=0&id=5eb8c0c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb8c0c6",
  null
  
)

export default component.exports